import { DevModeCdmSettingsService } from './devMode/dev-mode-cdm-settings-service';
import { DxpLuigiDataConfigService } from './dxp-luigi-data-config.service';
import { Injectable } from '@angular/core';
import { LuigiNode } from '@jukebox/common';
import {
  LocalConfigurationService,
  LuigiCoreService,
  LuigiNode as LuigiNodeExtended,
  NodeContext,
} from '@openmfp/portal-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class DxpLocalConfigurationService implements LocalConfigurationService {
  private cachedLocalNodes: LuigiNode[] | undefined;

  constructor(
    private cdmLuigiDataConfigService: DxpLuigiDataConfigService,
    private luigiCoreService: LuigiCoreService,
    private devModeCdmSettingsService: DevModeCdmSettingsService,
  ) {}

  public async getLocalNodes(): Promise<LuigiNodeExtended[]> {
    const language = this.luigiCoreService.i18n().getCurrentLocale();
    try {
      if (this.cachedLocalNodes) {
        return this.cachedLocalNodes as LuigiNodeExtended[];
      }

      const devModeSettings =
        await this.devModeCdmSettingsService.getDevModeSettings();

      this.cachedLocalNodes =
        await this.cdmLuigiDataConfigService.getLuigiDataFromConfigurations(
          { cdm: devModeSettings.configs },
          language,
        );
      const nodes = this.cachedLocalNodes;

      if (nodes)
        nodes.forEach((node: any) => {
          node.context = node.context || ({} as NodeContext);
          node.context.serviceProviderConfig =
            devModeSettings.serviceProviderConfig;
        });
      return nodes as LuigiNodeExtended[];
    } catch (e) {
      console.warn(`Failed to retrieve local luigi config.`, e);
      return [];
    }
  }
}
